import moment from 'moment'

// Mirror of server/src/helpers/shareCodeExpiry.js — keep the two in step.
export const SHARE_CODE_CHARS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
export const SHARE_CODE_LENGTH = 8
export const SHARE_CODE_MAX_HOURS = 24

export const EXPIRY_OPTIONS = [
  { hours: 4, label: '4 hours', caption: 'Same-shift handover' },
  { hours: 12, label: '12 hours', caption: 'Recommended', isDefault: true },
  { hours: 24, label: '24 hours', caption: 'The longest allowed' },
]

const randomIndex = (max) => {
  if (window.crypto?.getRandomValues) {
    const buffer = new Uint32Array(1)
    window.crypto.getRandomValues(buffer)
    return buffer[0] % max
  }
  return Math.floor(Math.random() * max)
}

export const generateShareCode = () => {
  let code = ''
  for (let i = 0; i < SHARE_CODE_LENGTH; i += 1) {
    code += SHARE_CODE_CHARS[randomIndex(SHARE_CODE_CHARS.length)]
  }
  return code
}

// 'revoked' | 'expired' | 'active'
export const getShareCodeStatus = (shareCode, now = moment()) => {
  if (!shareCode) return 'expired'
  if (shareCode.accessRevoked) return 'revoked'
  if (!shareCode.expires || !moment(shareCode.expires).isAfter(now)) {
    return 'expired'
  }
  return 'active'
}

export const SHARE_CODE_STATUS_META = {
  active: { label: 'Active', color: 'success' },
  expired: { label: 'Expired', color: 'default' },
  revoked: { label: 'Revoked', color: 'error' },
}

export const describeExpiry = (shareCode) => {
  const status = getShareCodeStatus(shareCode)
  if (status === 'revoked') return 'Access revoked'
  if (!shareCode?.expires) return 'No expiry recorded'
  const expires = moment(shareCode.expires)
  return status === 'active'
    ? `Expires ${expires.fromNow()} (${expires.format('HH:mm, D MMM')})`
    : `Expired ${expires.fromNow()}`
}

// Download attempts only — the revoke note on a code has no `success` flag.
export const summariseAttempts = (shareCode) => {
  const attempts = (shareCode?.accessLogs ?? []).filter(
    (entry) => typeof entry?.success === 'boolean',
  )
  return {
    successful: attempts.filter((entry) => entry.success).length,
    failed: attempts.filter((entry) => !entry.success).length,
  }
}

export const personName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(' ')

export const getAccessRecordUrl = () =>
  `${window.location.origin}/access-record`

export const sortNewestFirst = (codes = []) =>
  [...codes].sort(
    (a, b) =>
      moment(b?.createdAt ?? 0).valueOf() - moment(a?.createdAt ?? 0).valueOf(),
  )
